import {boundMethod} from "autobind-decorator";
import React from "react";

import {getDisplayLabel} from "@chart/chart-labels";
import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import NumberInput from "@toolbox/nativ-inputs/NumberInput";
import T, {intl2Str} from "@translate/T";
import {ILocalizedText} from "@translate/models";
import {IntlContext} from "react-intl";

interface IAucResolutionProps {
    value: number;
    onChange(value: number): void;
}

class AucResolution extends React.PureComponent<IAucResolutionProps> {
    @boundMethod
    public toggle(checked: boolean) {
        this.props.onChange(checked ? NaN : 10);
    }

    public render() {
        const {onChange, value} = this.props;
        const title: ILocalizedText = (intl) =>
            intl2Str(intl, "As provided by measuring device");

        return (
            <div className="form-row mb-2">
                <div className="col-sm-2">
                    <label>
                        <IntlContext.Consumer
                            children={getDisplayLabel({
                                name: (intl) =>
                                    intl2Str(
                                        intl,
                                        "Export to AUC radial resolution",
                                    ),
                                unit: (intl) => intl2Str(intl, "µm"),
                            })}
                        />
                    </label>
                </div>
                <InlineCheckbox
                    idSuffix="auc-resolution"
                    className="col-sm-1"
                    checked={isNaN(value)}
                    title={title}
                    toggle={this.toggle}
                >
                    <T>Full</T>
                </InlineCheckbox>
                {!isNaN(value) && (
                    <div className="col-sm-2 d-flex align-items-center">
                        <NumberInput
                            id="auc-input"
                            decimals={0}
                            min={1}
                            max={100}
                            step={1}
                            value={value}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default AucResolution;
